import * as s from './styles';

import type { ITextTagline } from './types';

const TextTagline = ({
  buttons,
  headline = '',
  headlineColor = 'sage',
  subhead = '',
  ...props
}: ITextTagline) => (
  <s.StyledTextTagline {...props}>
    <s.StyledGrid>
      <s.Flag fillColor='currentColor' iconName='BugMarkFilled' />
      <s.Headline $color={headlineColor} dangerouslySetInnerHTML={{ __html: headline }} />
      {(subhead !== '') && (
        <s.Subhead variant='h4'>{subhead}</s.Subhead>
      )}
      {(buttons && buttons.length > 0) && (
        <s.StyledButtons buttonColor='dark' buttons={buttons} variants={['primary', 'ghost']} />
      )}
    </s.StyledGrid>
  </s.StyledTextTagline>
);

export default TextTagline;
